import { render, staticRenderFns } from "./PrimeiroAcesso.vue?vue&type=template&id=7f063028&scoped=true"
import script from "./PrimeiroAcesso.vue?vue&type=script&lang=js"
export * from "./PrimeiroAcesso.vue?vue&type=script&lang=js"
import style0 from "./PrimeiroAcesso.vue?vue&type=style&index=0&id=7f063028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f063028",
  null
  
)

export default component.exports